import { ActivatedRouteSnapshot, ResolveFn, Route } from '@angular/router';
import { inject } from '@angular/core';
import { AuditlogService } from './auditlog.service';
import { AUDITLOG_PATH, AUDITLOG_TITLE } from '../mgs-path-defs';
import { mgsIconsResolver } from '../mgs-svg-icon.helper';
import { mgsAdminGuard } from '../mgs-guards';

const auditlogResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot) => {
  const auditlogService = inject(AuditlogService);

  const context = route.queryParams['context'];
  const key1 = route.queryParams['key1'];
  const requestId = route.queryParams['requestId'];
  if (context || key1 || requestId) {
    const search = { ...auditlogService.search() };
    if (context) {
      search.context = context;
    }
    if (requestId) {
      search.requestId = requestId;
    }
    if (key1) {
      search.key1 = key1;
    }
    auditlogService.updateSearchParams(search, false);
  }

  return auditlogService.load();
};

export const auditlogRoute: Route = {
  path: AUDITLOG_PATH,
  title: AUDITLOG_TITLE,
  loadComponent: () => import('./auditlog.component'),
  resolve: { auditlog: auditlogResolver, icons: mgsIconsResolver },
  canActivate: [mgsAdminGuard]
};
